import React from "react";
import { OCCASIONS } from "./templateData";
import { Cake, Heart, Baby, Home, Diamond, Trophy, Star, Wine, Sparkles } from "lucide-react";

const ICON_MAP = {
  cake: Cake,
  heart: Heart,
  baby: Baby,
  home: Home,
  ring: Diamond,
  trophy: Trophy,
  star: Star,
  wine: Wine,
  sparkles: Sparkles,
};

export const OccasionSelector = ({ selected, onSelect, customOccasion, onCustomOccasionChange }) => {
  return (
    <div data-testid="occasion-selector">
      <h2 className="text-2xl sm:text-3xl font-bold text-[#1E1B4B] text-center mb-2">
        What's the Occasion?
      </h2>
      <p className="text-[#475569] text-center mb-8 text-sm sm:text-base">
        Pick your celebration type to see matching invitation designs
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 max-w-4xl mx-auto">
        {OCCASIONS.map((occ) => {
          const Icon = ICON_MAP[occ.icon] || Sparkles;
          const isActive = selected === occ.id;
          return (
            <button
              key={occ.id}
              data-testid={`occasion-${occ.id}`}
              onClick={() => onSelect(occ.id)}
              className={`group relative flex flex-col items-center gap-2 p-4 sm:p-5 rounded-2xl border-2 transition-all duration-300 ${
                isActive
                  ? "border-[#E83E8C] bg-gradient-to-br from-[#E83E8C]/10 to-[#FF9F1C]/10 shadow-lg scale-[1.03]"
                  : "border-[#E8E8E8] bg-white hover:border-[#E83E8C]/40 hover:shadow-md hover:scale-[1.02]"
              }`}
            >
              <div
                className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center transition-all ${
                  isActive
                    ? "bg-gradient-to-br from-[#E83E8C] to-[#FF9F1C] text-white shadow-md"
                    : "bg-[#FFFAF5] text-[#E83E8C] group-hover:bg-[#E83E8C]/10"
                }`}
              >
                <Icon size={24} />
              </div>
              <span
                className={`text-sm sm:text-base font-semibold transition-colors ${
                  isActive ? "text-[#E83E8C]" : "text-[#1E1B4B]"
                }`}
              >
                {occ.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Custom occasion name input when "Other" is selected */}
      {selected === "other" && (
        <div className="max-w-md mx-auto mt-6" data-testid="custom-occasion-input-wrapper">
          <label className="block text-sm font-semibold text-[#475569] mb-2 text-center">
            What's your occasion?
          </label>
          <input
            data-testid="custom-occasion-input"
            type="text"
            value={customOccasion || ""}
            onChange={(e) => onCustomOccasionChange(e.target.value)}
            placeholder="e.g., Farewell Party, Puja, Graduation..."
            className="w-full px-4 py-3 border-2 border-[#E83E8C]/30 rounded-xl text-center text-base font-medium focus:ring-2 focus:ring-[#E83E8C]/20 focus:border-[#E83E8C] outline-none"
          />
        </div>
      )}
    </div>
  );
};
